<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="17">
          <section class="section-card realtime-statics" v-loading="loading">
              <div class="section-card-header">
                  <div class="section-card-title">
                      实时概况
                  </div>
                  <div class="header-small">
                      更新时间：{{Date.now()/1000 | datetime('yyyy-MM-dd hh:mm:ss')}}
                  </div>
                  <!-- <ul class="header-filters">
                      <li class="filter-item">全店</li>
                      <li class="filter-item">网店</li>
                      <li class="filter-item">所有门店</li>
                  </ul> -->
              </div>
              <div>
                  <el-row class="analysis" :gutter="20">
                      <el-col :span="12">
                          <div class="view-flex">
                              <div class="view-flex-item" style="color: blue;font-weight:bold;">
                                  <div class="label">总数</div>
                                  <div class="real-data">{{SumMoney}}</div>
                              </div>
                              <div class="view-flex-item" style="color: green;font-weight:bold;">
                                  <div class="label">已使用</div>
                                  <div class="real-data">{{SumCoupon}}</div>
                                  
                              </div>
                              <div class="view-flex-item" style="color: red;font-weight:bold;">
                                  <div class="label">待分配</div>
                                  <div class="real-data">{{SumIntegral}}</div>
                                  
                              </div>
                              <div class="view-flex-item" style="color: green;font-weight:bold;">
                                  <div class="label">未使用</div>
                                  <div class="real-data">{{SumPeople}}</div>
                                  
                              </div>
                          </div>
                      </el-col>
                      
                  </el-row>
                  
              </div>
          </section>
      </el-col>
  </el-row>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-input placeholder="用户ID" v-model="params.user_id">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :md="6" :lg="5">
        <el-date-picker v-model="creat_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width:100%;" @change="dateChange" size=""></el-date-picker>
      </el-col>
      <el-col :span="2">
        <!-- <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button> -->
      </el-col>
    </el-row>
    <el-table :data="userList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="pre_member_id" label="用户ID">
        <template slot-scope="scope">
          {{scope.row.pre_member_id}}
        </template>
      </el-table-column>
      <el-table-column prop="card" label="会员卡号">
        <template slot-scope="scope">
          {{scope.row.card}}
        </template>
      </el-table-column>
      <el-table-column prop="id_in_yingke" label="会员卡ID">
        <template slot-scope="scope">
          {{scope.row.id_in_yingke}}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{scope.row.status}}
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.page_size">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {Message} from 'element-ui'
  import {getcardPoolist} from '../../../api/member'

  export default {
    data() {
      return {
        creat_time:'',
        isEdit: false,
        userList: [],
        loading: false,
        exportloading:false,
        total_count: 0,
        params: {
          page: 1,
          page_size: 20,
          user_id: ''
        },

        resList: [{label: 'true', value: 'true'},
          {label: 'false', value: 'false'}
        ],
        form: {
          id: '',

          description: ''
        },
        SumMoney:0,
        SumCoupon:0,
        SumIntegral:0,
        SumPeople:0,
        employeeDialog: false,
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      saveTimeData() {
        this.employeeDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          pullOrder(this.form).then(res => {
              this.$message({
                type: 'success',
                message: '获取成功'
              })
              this.getDataList()

          })
        } else {
          this.$message.error('缺少Id')
          this.getDataList()
        }
      },
      // eslint-disable-next-line camelcase
      handleCurrentChange(page_num) {
        // eslint-disable-next-line camelcase
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate() { // 添加
        this.employeeDialog = true
        // eslint-disable-next-line standard/object-curly-even-spacing
        this.form = {tag_id: '', tag_name: '', tag_color: '#ff1939', font_color: '#ffffff', description: ''}
      },
      editAction(index, row) { // 编辑
        this.form = row
        this.employeeDialog = true
      },
      preview(index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData() {
          this.params.page = 1
          console.log(this.params);
          this.getDataList()
      },
      getDataList() {
        this.loading = true
        getcardPoolist(this.params).then(response => {
          this.userList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.SumMoney = response.data.data.sum_money?response.data.data.sum_money:0
          this.SumCoupon = response.data.data.sum_coupon?response.data.data.sum_coupon:0
          this.SumIntegral = response.data.data.sum_integral?response.data.data.sum_integral:0
          this.SumPeople = response.data.data.sum_people?response.data.data.sum_people:0
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },

      getTaskTime(strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y + '-' + m + '-' + d
        return str
      },
      getTimeStr(date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog() {
        this.employeeDialog = false
      },
      dateChange (val) {
        console.log(val)

        if (val.length > 0) {
          this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          this.params.time_start_begin = this.time_start_begin
          this.params.time_start_end = this.time_start_end
        } else {
          this.time_start_begin = ''
          this.time_start_end = ''
          this.params.time_start_begin = ''
          this.params.time_start_end = ''
        }
        this.params.page = 1

        this.getDataList()
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000 
      },
    },

    mounted() {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }
  .section-card {
    padding: 30px;
    background: #fff;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    &.realtime-statics {
        height: 138px;
    }
    &.chart-statics {
        height: 318px;
    }
    .section-card-header {
        display: flex;
        align-items: flex-end;
        padding-bottom: 20px;
        .section-card-title {
            margin-right: 20px;
            font-size: 16px;
            font-weight: 600;
        }
        
      .analysis {
        padding-left: 20px;
        padding-top: 10px;
        .label {
            font-size: 12px;
            color: #999;
        }
        .real-data {
            font-size: 20px;
            font-family: "Helvetica Neue";
            font-weight: 500;
        }
        .history-data {
            font-size: 12px;
            color: #ccc;
        }
    }
        .header-small {
            flex: 1;
            font-size: 12px;
            color: #ccc;
        }
        .header-filters {
            display: flex;
            .filter-item {
                position: relative;
                padding: 0 15px;
                color: #999;
                font-size: 12px;
                &::after {
                    position: absolute;
                    left: 0;
                    top: 20%;
                    bottom: 20%;
                    width: 1px;
                    background: #efefef;
                    content: "";
                }
                &:first-child::after {
                    content: none;
                }
            }
        }
    }
  }
  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 10px;

    img {
      width: 90%;
    }
  }

  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }

  .service-label .el-checkbox:first-child {
    margin-left: 15px;
  }

  .service-label .el-input:first-child {
    margin-left: 15px;
  }

  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100% !important;
    }

    img {
      width: 100%;
    }
  }

  .grid-attribute {
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// pool.vue?4aecd471